import { DataBaseNodes } from '@lib';
import { useSiteStore } from '@stores';
import { SourceUnsubscribe } from '@type';
import { getDateUTCOffset } from '@utils';

import { Preferences, ReminderNodeValue } from '../types';
import { BaseGateway } from './base.gateway';

export class ReminderGateway extends BaseGateway {
  subscribeToReminders = (
    callback: (reminders: ReminderNodeValue[]) => unknown
  ): SourceUnsubscribe => {
    return this.sourceService.subscribeToChild(
      `${DataBaseNodes.Patients}/${this.config.patientSourceUUID}/${DataBaseNodes.Reminders}`,
      snapshot => {
        if (!snapshot.exists()) return;
        const reminders = Object.values(
          snapshot.val() as { [key: string]: ReminderNodeValue }
        );
        callback(reminders);
      }
    );
  };

  subscribeToRemindersRemoved = (
    callback: (snapshot: ReminderNodeValue) => unknown
  ): SourceUnsubscribe => {
    return this.sourceService.subscribeToChildRemoved(
      `${DataBaseNodes.Patients}/${this.config.patientSourceUUID}/${DataBaseNodes.Reminders}`,
      snapshot => {
        if (!snapshot.exists()) return;
        callback(snapshot.val() as ReminderNodeValue);
      }
    );
  };

  requestReminders = async () => {
    const { getSiteByProjectId } = useSiteStore.getState();
    const { siteUuid } = getSiteByProjectId(this.config.projectId as string);

    const payload = {
      preference: Preferences.Reminders.FetchReminders,
      type: Preferences.Reminders.FetchReminders,
      utcOffset: getDateUTCOffset(),
      includeAnsweredMedications: true,
    };

    return await this.sendRequest(
      siteUuid,
      payload,
      DataBaseNodes.Request,
      this.config.patientSourceUUID
    );
  };
}
